export default __webpack_public_path__ + "static/media/mb-logo.dcd7fe29.png";